/* eslint-disable prefer-const */
/* eslint-disable eqeqeq */
/* eslint-disable object-shorthand */
/* eslint-disable max-len */
/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-add-local-document',
  templateUrl: './add-local-document.component.html',
  styleUrls: ['./add-local-document.component.scss'],
})
export class AddLocalDocumentComponent implements OnInit {
  @Input() data: any;
  @Input() assetTypeId: any;
  @Input() assetsId?: any;
  @Input() folderType: any;
  @Input() documentId: any;
  @Input() status?: any;
  @Input() sectionType?: any;
  formTitle: string;
  statusListForm: FormGroup;
  maxDate: Date = new Date();
  isSaving: boolean = false;
  public statusListSub: Subscription;
  public awdbSub: Subscription;
  editableForm: boolean = true;
  summaryApiGetCallResponse: boolean = false;
  constructor(private modalController: ModalController, private snackBar: MatSnackBar, public apiService: ApiService) {}

  ngOnInit() {
    console.log(this.documentId);
    this.formTitle = 'Add Local Document Folder';
    this.statusListForm = new FormGroup({
      prefix: new FormControl('', [Validators.required]),
      name: new FormControl('', [Validators.required]),
    });
    if (this.data !== null) {
      this.summaryApiGetCallResponse = true;
      this.setForm();
    }
  }

  public setForm(): void {
    console.log(this.data);
    if (this.data?.id > 0) {
      const fullName = this.data?.name || '';
      const nameParts = fullName.split(' ');
      const prefixPart = nameParts[0]; // e.g., "A."
      const remainingName = nameParts.slice(1).join(' '); // everything after the prefix
      this.formTitle = this.data ? 'Edit Local Document Folder' : 'Add Local Document Folder';
      this.statusListForm = new FormGroup({
        prefix: new FormControl(prefixPart, [Validators.required]),
        name: new FormControl(remainingName, [Validators.required]),
        id: new FormControl(this.data?.id),
      });
    }
    this.summaryApiGetCallResponse = false;
  }

  dismissModal() {
    this.modalController.dismiss({
      dismissed: false,
    });
  }

  toggleEditableForm(): void {
    this.editableForm = true;
  }
  isDisabled(): boolean {
    return this.data ? this.editableForm : false;
  }

  public submit(): void {
    if (this.statusListForm.invalid) {
      this.statusListForm.markAllAsTouched();
      return;
    }
    this.isSaving = true;
    this.statusListApiCall();
  }

  public statusListApiCall(): void {
    try {
      var obj: any;
      obj = {
        name: this.statusListForm.value.prefix + ' ' + this.statusListForm.value.name,
        assetTypeId: this.assetTypeId,
        folderType: this.folderType,
      };
      if (this.assetsId) {
        obj['assetId'] = this.assetsId;
      }
      if (this.documentId) {
        obj['parentId'] = this.documentId;
      }
      if (this.sectionType) {
        obj['section'] = this.sectionType;
      }
      if (this.data === null) {
        let data = {
          recordObj: obj,
        };
        (this.statusListSub = this.apiService.addDocumentsFolder(data).subscribe(
          (res: any) => {
            if (res !== null) {
              this.apiService.openSnackBar('Data Created Successfully');
              this.statusListForm.reset();
              this.modalController.dismiss({
                dismissed: true,
              });
            }
            this.isSaving = false;
          },
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
          }
        )),
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
          };
      } else {
        obj['id'] = Number(this.data?.id);
        let data = {
          recordObj: obj,
        };
        (this.statusListSub = this.apiService.updateDocumentsFolder(data).subscribe(
          (res: any) => {
            if (res !== null) {
              this.apiService.openSnackBar('Data Updated Successfully');
              this.statusListForm.reset();
              this.modalController.dismiss({
                dismissed: true,
              });
            }
            this.isSaving = false;
          },
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
          }
        )),
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
          };
      }

      // if(this.documentType === 'Header'){
      //   delete obj['docTypeHeaderID']
      //   delete obj['docTypeCategoryId']
      //   if (this.data === null){
      //     let data ={
      //       recordObj: obj,
      //     };
      //     this.statusListSub = this.apiService.addHeaderLocalFolder(data).subscribe((res: any) => {
      //       if(res !== null){
      //           this.apiService.openSnackBar("Data Created Successfully");
      //           this.statusListForm.reset()
      //           this.modalController.dismiss({
      //             'dismissed': true
      //           });

      //       }
      //       this.isSaving = false;
      //     },(err:any)=>{
      //       this.isSaving = false;
      //       this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)

      //     }),(err:any)=>{
      //       this.isSaving = false;
      //       this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      //     };
      //   }
      //   else{
      //     obj['id']= this.data?.id
      //     let data ={
      //       recordObj: obj,
      //     };
      //     this.statusListSub = this.apiService.updateHeaderLocalFolder(data).subscribe((res: any) => {
      //       if(res !== null){
      //         this.apiService.openSnackBar("Data Updated Successfully");
      //           this.statusListForm.reset()
      //           this.modalController.dismiss({
      //             'dismissed': true
      //           });
      //         }
      //          this.isSaving = false;
      //     },(err:any)=>{
      //        this.isSaving = false;
      //       this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)

      //     }),(err:any)=>{
      //        this.isSaving = false;
      //       this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      //     };
      //   }
      // }
      // else if(this.documentType === 'Category'){
      //     obj['docTypeHeaderID']=this.documentId
      //   if (this.data === null){
      //     let data ={
      //       recordObj: obj,
      //     };
      //     this.statusListSub = this.apiService.addCategoryLocalFolder(data).subscribe((res: any) => {
      //       if(res !== null){
      //           this.apiService.openSnackBar("Data Created Successfully");
      //           this.statusListForm.reset()
      //           this.modalController.dismiss({
      //             'dismissed': true
      //           });

      //       }
      //       this.isSaving = false;
      //     },(err:any)=>{
      //       this.isSaving = false;
      //       this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)

      //     }),(err:any)=>{
      //       this.isSaving = false;
      //       this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      //     };
      //   }
      //   else{
      //     obj['id']= this.data?.id
      //     let data ={
      //       recordObj: obj,
      //     };
      //     this.statusListSub = this.apiService.updateCatLocalFolder(data).subscribe((res: any) => {
      //       if(res !== null){
      //         this.apiService.openSnackBar("Data Updated Successfully");
      //           this.statusListForm.reset()
      //           this.modalController.dismiss({
      //             'dismissed': true
      //           });
      //         }
      //          this.isSaving = false;
      //     },(err:any)=>{
      //        this.isSaving = false;
      //       this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)

      //     }),(err:any)=>{
      //        this.isSaving = false;
      //       this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      //     };
      //   }
      // }else{
      //   obj['docTypeCategoryId']=this.documentId
      //   if (this.data === null){
      //     let data ={
      //       recordObj: obj,
      //     };
      //     this.statusListSub = this.apiService.addTypeLocalFolder(data).subscribe((res: any) => {
      //       if(res !== null){
      //           this.apiService.openSnackBar("Data Created Successfully");
      //           this.statusListForm.reset()
      //           this.modalController.dismiss({
      //             'dismissed': true
      //           });

      //       }
      //       this.isSaving = false;
      //     },(err:any)=>{
      //       this.isSaving = false;
      //       this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)

      //     }),(err:any)=>{
      //       this.isSaving = false;
      //       this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      //     };
      //   }
      //   else{
      //     obj['id']= this.data?.id
      //     let data ={
      //       recordObj: obj,
      //     };
      //     this.statusListSub = this.apiService.updateTypeLocalFolder(data).subscribe((res: any) => {
      //       if(res !== null){
      //         this.apiService.openSnackBar("Data Updated Successfully");
      //           this.statusListForm.reset()
      //           this.modalController.dismiss({
      //             'dismissed': true
      //           });
      //         }
      //          this.isSaving = false;
      //     },(err:any)=>{
      //        this.isSaving = false;
      //       this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)

      //     }),(err:any)=>{
      //        this.isSaving = false;
      //       this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      //     };
      //   }
      // }
    } catch (err) {
      this.isSaving = false;
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }
  restrictSpaceInput(event: any, control: AbstractControl): void {
    const inputValue = event.target.value;

    // Remove all spaces
    const sanitizedValue = inputValue.replace(/\s+/g, '');

    // Set the sanitized value back to the control
    if (control) {
      control.setValue(sanitizedValue, { emitEvent: false });
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.statusListSub !== null && this.statusListSub !== undefined) {
      this.statusListSub.unsubscribe();
    }
  }
}
